module.exports = __webpack_public_path__ + "media/images/stop-box-333e5d8a0740bc1c8e7a12e9a149ca7a.svg";